import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { MetricCard, MetricCardsGrid } from "../shared";
import type { RevenueKpiMetric } from "./revenueMappers";

const LOADING_METRICS: RevenueKpiMetric[] = [
  {
    title: "Total Revenue",
    value: "0€",
    trend: "neutral",
    icon: null,
  },
  {
    title: "Avg. check per reservation",
    value: "0€",
    trend: "neutral",
    icon: null,
  },
];

function translateRevenueKpiTitle(
  t: (key: string, fallback: string) => string,
  title: string,
): string {
  switch (title) {
    case "Total Revenue":
      return t("analytics.revenue.totalRevenue", "Total Revenue");
    case "Avg. check per reservation":
      return t(
        "analytics.revenue.avgCheckPerReservation",
        "Avg. check per reservation",
      );
    default:
      return title;
  }
}

interface RevenueKpiCardsProps {
  metrics?: RevenueKpiMetric[];
  isLoading?: boolean;
  isComparisonLoading?: boolean;
}

export const RevenueKpiCards: React.FC<RevenueKpiCardsProps> = ({
  metrics = LOADING_METRICS,
  isLoading = false,
  isComparisonLoading = false,
}) => {
  const { t } = useTranslation();
  const displayMetrics = isLoading ? LOADING_METRICS : metrics;

  const translatedMetrics = useMemo(
    () =>
      displayMetrics.map((metric) => ({
        ...metric,
        title: translateRevenueKpiTitle(t, metric.title),
      })),
    [displayMetrics, t],
  );

  return (
    <MetricCardsGrid columns={2}>
      {translatedMetrics.map((metric) => (
        <MetricCard
          key={metric.title}
          title={metric.title}
          value={metric.value}
          delta={isComparisonLoading ? undefined : metric.delta}
          trend={metric.trend}
          icon={metric.icon}
          width="fill"
        />
      ))}
    </MetricCardsGrid>
  );
};
